import { Component, Element, Event, EventEmitter, h, Host, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'uui-checkbox',
  styleUrl: './uui-checkbox.css',
  shadow: false,
  scoped: true
})
export class UUICheckbox {
  @Prop({ mutable: true, reflect: false }) checked = false;
  @Prop({ mutable: true, reflect: true }) label?: string;
  @Prop({ reflect: true }) disabled = false;
  /** makes checkbox indeterminate   */
  @Prop({ reflect: true }) indeterminate = false;
  @Prop({ mutable: true, reflect: true }) error = false;
  /**
   * The value of the checkbox does not mean if it's checked or not, use the `checked`
   * property for that.
   *
   * The value of a checkbox is analogous to the value of an `<input type="checkbox">`,
   * it's only used when the checkbox participates in a native `<form>`.
   */
  @Prop() value = 'on';
  @Prop({ reflect: true }) name: string;
  /** passes back the event */
  @Event({ bubbles: true, composed: true }) toggle?: EventEmitter<any>;
  @Event({ bubbles: true, composed: true }) toggleChange?: EventEmitter<any>;
  /** passes back the checked state (either true or false) */
  @Event() valueChanged: EventEmitter<boolean>;
  @Prop() inputProps: { [key: string]: string | number };
  @Element() el: HTMLElement;

  _inputId = `_cb_${_checkboxId++}`;

  get input() {
    return this.el.querySelector('input');
  }

  connectedCallback() {
    if (this.input) {
      this.input.checked = this.checked;
    }
  }

  @Watch("indeterminate")
  onIndeterminateChange(newVal: boolean) {
    if(newVal === true) {
      this.input.indeterminate = true;
    } else {
      this.input.indeterminate = false;
    }
  }

  componentDidLoad() {
    const setInitialIndeterminateState = () => {
      // wait until component is actually rendered. item is null in some circumstances
      if(!this.input) {
        return requestAnimationFrame(setInitialIndeterminateState);
      }
      this.onIndeterminateChange(this.indeterminate);
    }


    setInitialIndeterminateState();
  }

  onCheckboxToggle(e) {
    console.warn(
      'toggle will be deprecated in a future release. Please use toggleChange.'
    );
    if (this.disabled) {
      return;
    }
    this.checked = this.input?.checked;
    this.toggle.emit(e);
    this.valueChanged.emit(this.checked);
  }

  onCheckboxToggleChange(e) {
    if (this.disabled) {
      return;
    }
    
    this.indeterminate = false;
    this.onIndeterminateChange(false);
    
    this.checked = this.input?.checked;
    this.toggleChange.emit(e);
    this.valueChanged.emit(this.checked);
  }

  render() {
    return (
      <Host
        aria-checked={`${this.checked}`}
        aria-hidden={this.disabled ? 'true' : null}
        role="checkbox"
      >
        <input
          type="checkbox"
          aria-checked={`${this.checked}`}
          id={this._inputId}
          value={this.value}
          name={this.name}
          checked={this.checked}
          disabled={this.disabled}
          onChange={e => {
            if (this.toggleChange) {
              return this.onCheckboxToggleChange(e);
            }

            this.onCheckboxToggle(e);
          }}
          {...this.inputProps}
        />
        <label htmlFor={this._inputId}>
          <slot />
        </label>
      </Host>
    );
  }
}
let _checkboxId = 0;
